import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, useTheme } from "@mui/material";
const SuggestedByAiHint = () => {
  const tRP = "components.edit_outgoing_mail";
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Typography style={{ color: theme.palette.primary.main, fontSize: "10px" }}>
      {`${t(`${tRP}.suggested_by_ai`)}`}
    </Typography>
  );
};

export default SuggestedByAiHint;
